import { NavigationRouteContext } from '@react-navigation/native';
import React, { useEffect, useState } from 'react';
import { navigationRef } from './NavigationWrapper';
/**
 * Fallback route used before the navigator is ready (or when no route is
 * focused yet). It keeps `useRoute()` from throwing inside helper views and
 * resolves to "no params", which is a safe default for consumers like
 * pagination (offset/limit fall back to their defaults).
 */
const FALLBACK_ROUTE = {
    key: 'helper-view-root',
    name: 'HelperViewRoot',
    params: undefined,
};
function getActiveRoute() {
    if (navigationRef.isReady()) {
        return (navigationRef.getCurrentRoute() ??
            FALLBACK_ROUTE);
    }
    return FALLBACK_ROUTE;
}
/**
 * Bridges the currently-focused screen's route into its subtree via
 * `NavigationRouteContext`.
 *
 * Global helper views (bottom drawers, overlays, snackbars, ...) render as a
 * sibling of the navigator, so they sit outside any screen and have no route
 * context. Any feature content shown there that calls `useRoute()` — e.g.
 * `useGQLPaginatedQuery` → `usePaginationState` — would otherwise throw. This
 * provider mirrors the active route so those consumers behave as if they were
 * rendered on the focused screen.
 */
const ActiveRouteProvider = ({ children, }) => {
    const [route, setRoute] = useState(getActiveRoute);
    useEffect(() => {
        const sync = () => setRoute(getActiveRoute());
        // Sync immediately in case the navigator became ready between the initial
        // render and this effect running.
        sync();
        return navigationRef.addListener('state', sync);
    }, []);
    return (React.createElement(NavigationRouteContext.Provider, { value: route }, children));
};
export default ActiveRouteProvider;
